import { SelectOption } from '../models';

export enum DocumentStatus {
  Unknown = 'unknown',
  Unapproved = 'unapproved',
  Approved = 'approved',
  Rejected = 'rejected',
  Expired = 'expired',
  ExpireSoon = 'expire_soon',
}

export const DocumentStatuses: SelectOption[] = [
  { value: DocumentStatus.Unapproved, label: 'Unapproved', color: '#aeaeb2' },
  { value: DocumentStatus.Unknown, label: 'Unknown', color: '#aeaeb2' },
  { value: DocumentStatus.Approved, label: 'Approved', color: '#16b364' },
  { value: DocumentStatus.Rejected, label: 'Rejected', color: '#d92d20' },
  { value: DocumentStatus.Expired, label: 'Expired', color: '#d92d20' },
  { value: DocumentStatus.ExpireSoon, label: 'Expire soon', color: '#f79009' },
];
